import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import FaqServices from '../../services/FaqServices';
import Pagetitle from "../../component/PageTitle";

function AddFAQ() {
  const navigate = useNavigate();
  const [faqCat, setFaqCat] = useState([]);
  const [englishForm, setEnglishForm] = useState({
    language: 'English',
    category: '',
    question: '',
    answer: '',
  });
  const [hindiForm, setHindiForm] = useState({
    language: 'Hindi',
    category: '',
    question: '',
    answer: '',
  });

  useEffect(() => {
    const fetchFaqCategory = async () => {
      try {
        const res = await FaqServices.getAllFaqCategory();
        if (res.status) {
          setFaqCat(res.data);
        } else {
          alert('Failed to fetch category');
        }
      } catch (error) {
        console.error('Error fetching category', error);
        alert('Failed to fetch category');
      }
    };
    fetchFaqCategory();
  }, []);

  const handleInputChange = (event, formSetter) => {
    const { name, value } = event.target;
    formSetter((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (event, formValues) => {
    event.preventDefault();
    try {
      const response = await FaqServices.AddFaq(formValues);
      if (response.status) {
        alert(`${formValues.language} FAQ added successfully`);
        navigate('/faq-list')
      } else {
        alert('Something went wrong');
      }
    } catch (error) {
      console.error('Failed to add FAQ', error);
      alert('Failed to add FAQ');
    }
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="row">
        <div className="container-box-top-header justify-content-end col-md-12 mb-0">
          <div className="sub-title-box-right">
            <Link className="site-btn-green" to="/faq-list">
              FAQs List
            </Link>
          </div>
        </div>

        {/* English Form */}
        <div className="col-md-12">
          <div className="container-box">
            <div className="container-box-top-header">
              <h4>In English</h4>
            </div>
            <div className="container-box-inner px-4">
              <form onSubmit={(e) => handleSubmit(e, englishForm)}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Select Type</label>
                      <select
                        className="form-select"
                        name="category"
                        value={englishForm.category}
                        onChange={(e) => handleInputChange(e, setEnglishForm)}
                        required
                      >
                        <option value="">Select Category</option>
                        {faqCat.map((cat) => (
                          <option key={cat._id} value={cat._id}>
                            {cat.titleEnglish}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Frequently Asked Questions Title</label>
                      <input
                        type="text"
                        name="question"
                        className="form-control"
                        value={englishForm.question}
                        onChange={(e) => handleInputChange(e, setEnglishForm)}
                        placeholder="Enter Frequently Asked Questions Title"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="input-field">
                      <label>Answer</label>
                      <textarea
                        name="answer"
                        value={englishForm.answer}
                        onChange={(e) => handleInputChange(e, setEnglishForm)}
                        placeholder="Enter here"
                        className="form-control"
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
                <button className="site-btn-green" style={{backgroundColor:'#699836'}} type="submit">
                  Save
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Hindi Form */}
        <div className="col-md-12">
          <div className="container-box">
            <div className="container-box-top-header">
              <h4>In Hindi</h4>
            </div>
            <div className="container-box-inner px-4">
              <form onSubmit={(e) => handleSubmit(e, hindiForm)}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Select Type</label>
                      <select
                        className="form-select"
                        name="category"
                        value={hindiForm.category}
                        onChange={(e) => handleInputChange(e, setHindiForm)}
                        required
                      >
                        <option value="">Select Category</option>
                        {faqCat.map((cat) => (
                          <option key={cat._id} value={cat._id}>
                            {cat.titleHindi}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Frequently Asked Questions Title</label>
                      <input
                        type="text"
                        name="question"
                        className="form-control"
                        value={hindiForm.question}
                        onChange={(e) => handleInputChange(e, setHindiForm)}
                        placeholder="Enter Frequently Asked Questions Title"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="input-field">
                      <label>Answer</label>
                      <textarea
                        name="answer"
                        value={hindiForm.answer}
                        onChange={(e) => handleInputChange(e, setHindiForm)}
                        placeholder="Enter here"
                        className="form-control"
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
                <button className="site-btn-green" style={{backgroundColor:'#699836'}} type="submit">
                  Save
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddFAQ;
